<template>
	<el-card shadow="never" class="aui-card--fill">
		<el-row style="background-color: #F3F4F4;">
			<el-col :xs="24" :md="6" style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;">
				<img style="width: 16px;height: 16px;margin-right: 12px;" src="../../../assets/img/user-list.png" />
				任务详情
			</el-col>
			<el-col :xs="24" :md="18">
				<el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" style="text-align: right;">
					<el-form-item><el-button class="refreshBtn" style="left: 500px;" type="info" @click="getDataList()">刷新</el-button></el-form-item>
					<el-form-item><el-button class="refreshBtn" style="left: 500px;" type="info" @click="$router.go(-1)">返回列表</el-button></el-form-item>
				</el-form>
			</el-col>
		</el-row>
		<div style="padding: 50px;">
		<el-form :model="ruleForm" ref="ruleForm" :rules="rules" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
			<el-row>
				<el-col :md="24" :lg="6">
					<el-form-item label="任务大类" prop="taskType"><ren-select v-model="dataForm.taskType" isDisabled=true dict-type="taskType" readonly="true"></ren-select></el-form-item>
				</el-col>
			</el-row>
		    <el-form-item label="任务简述" prop="taskDesc">
		        <el-input v-model="dataForm.taskDesc" rows="2" style="width: 60%;" placeholder="任务简述" disabled="disabled"></el-input>
		    </el-form-item>
		    <el-form-item label="结算价格及结算方式" prop="taskRequire">
		        <el-input type="textarea" rows="4" style="width: 70%;" v-model="dataForm.taskRequire" placeholder="结算价格及结算方式" disabled="disabled"></el-input>
		    </el-form-item>

		    <el-row>
				<el-col :span="6">
				    <el-form-item label="需求人数" prop="requirePerson">
				        <el-input style="width: 95%;" v-model="dataForm.requirePerson" placeholder="需求人数" disabled="disabled"><i slot="suffix" style="font-style:normal;margin-right: 10px;">人</i></el-input>

				    </el-form-item>
				</el-col>
		        <el-col :span="6">
		            <el-form-item label="预算" prop="budget">
		                <el-input style="width: 95%;" v-model="dataForm.budget" placeholder="预算" disabled="disabled"><i slot="suffix" style="font-style:normal;margin-right: 10px;">元</i></el-input>
		            </el-form-item>
		        </el-col>
		        <el-col :span="6">
		            <el-form-item label="合同编号" prop="contractCode">
		                <el-input style="width: 95%;" v-model="dataForm.contractCode" placeholder="合同编号" disabled="disabled"></el-input>
		            </el-form-item>
		        </el-col>
		    </el-row>
		    <el-form-item label="任务周期" prop="startDate">
				<el-date-picker v-model="dataForm.startDate" disabled="disabled" start-placeholder="开始日期" align="right" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:SS"></el-date-picker>
				  ~
				<el-date-picker v-model="dataForm.endDate" disabled="disabled" end-placeholder="结束日期"align="right"  type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:SS"></el-date-picker>
		    </el-form-item>
			 <el-form-item>
					<el-button type="primary" @click="dataFormSubmitHandle()">接受任务</el-button>
			</el-form-item>

		</el-form>

		<el-row style="border-top: 5px solid #F3F4F4;" v-if="dataForm.acceptDTOList.length > 0">
			<div style="font-size: 14px;font-weight: bold;color: #333333;line-height: 40px;">任务执行情况</div>
			<el-table :data="dataForm.acceptDTOList" style="width: 100%;">
			    <el-table-column label="序号" type="index" width="50" align="center">
			    	<template slot-scope="scope">
			    		<span>{{scope.$index + 1 }}</span>
			    	</template>
			    </el-table-column>
				<el-table-column prop="publishName" label="发包方" header-align="center" align="center"></el-table-column>
			    <el-table-column prop="contractCode" label="个人合同编号" header-align="center" align="center"></el-table-column>
			    <el-table-column prop="assignee" label="被分配方" header-align="center" align="center"></el-table-column>
			    <el-table-column prop="realName" label="接受方" header-align="center" align="center"></el-table-column>
			    <el-table-column prop="money" label="支付金额（元）" header-align="center" align="center">
					<template slot-scope="scope">
						{{Number(scope.row.money).toFixed(2)}}
					</template>
				</el-table-column>

				<el-table-column prop="finishProofPath" label="完工证明" header-align="center" align="center">
					<template slot-scope="scope">
						<el-button type="primary" v-if="scope.row.finishProofPath!=null && scope.row.finishProofPath!=''" @click="yulan(scope.row.finishProofPath)">查看</el-button>
					</template>
				</el-table-column>

				<el-table-column prop="acceptDate" label="操作日期" header-align="center" align="center"></el-table-column>

				<el-table-column prop="status" label="用户任务状态" header-align="center" align="center">
					<template slot-scope="scope">
						{{ $getDictLabel("acceptTaskStatus", scope.row.status) }}
					</template>
				</el-table-column>
			</el-table>
		</el-row>

		<el-row style="border-top: 5px solid #F3F4F4;">
			<div style="font-size: 14px;font-weight: bold;color: #333333;line-height: 40px;">任务状态</div>
			<div style="line-height: 25px;padding: 10px 0;font-size: 12px;">
				<p style="margin: 0;">

					任务发布编号<span style="margin-left: 30px;">{{dataForm.taskCode}}</span>
					</p>
					<p style="margin: 0;" v-for="(value,key) in dataForm.processDTOList">
						<span style="width: 10px;height: 10px;border-radius: 5px;background-color: #3371F1;display: inline-block;margin: 0 15px;"></span>
						{{value.createDate}}<span style="margin-left: 30px;">{{value.operation}}</span><span style="margin-left: 30px;">{{value.content}}</span>
						</p>
			</div>
		</el-row>

		</div>

		<el-dialog :show-close="false" top="6vh" width="1056px" title="平台服务协议" :visible="dialogVisible">
			<div style="font-size: 12px;color: #333;line-height: 34px;text-indent: 24px;text-align: left;height: 640px;overflow-y: scroll;">
				<p>众联平台（“我们”）非常重视用户的隐私和个人信息保护。您在使用我们的产品与/或服务时，我们可能会收集和使用您的相关信息。我们希望通过《隐私政策》（“本隐私政策”）向您说明我们在您使用我们的产品与/或服务时如何收集、使用、保存、共享和转让这些信息，以及我们为您提供的访问、更新、删除和保护这些信息的方式。本政策将帮助您了解以下内容：</p>
				<p>
					1、适用范围<br />
					<span style="display: inline-block;width: 24px;"></span>2、我们收集您的信息的范围<br/>
					<span style="display: inline-block;width: 24px;"></span>3、我们收集您的信息的方式<br />
					<span style="display: inline-block;width: 24px;"></span>4、我们如何共享、转让、公开披露您的个人信息<br />
					<span style="display: inline-block;width: 24px;"></span>5、我们如何保护和保存您的个人信息<br />
					<span style="display: inline-block;width: 24px;"></span>6、您如何管理个人信息<br />
					<span style="display: inline-block;width: 24px;"></span>7、未成年人信息的保护<br />
					<span style="display: inline-block;width: 24px;"></span>8、通知和修订<br />
					<span style="display: inline-block;width: 24px;"></span>9、如何联系我们 本隐私政策与您所使用的京东智联云服务以及该服务所包括的各种业务功能（以下统称“我们的产品与/或服务”）息息相关，希望您在使用我们的产品与/或服务前仔细阅读并确认您已经充分理解本政策所写明的内容，并让您可以按照本隐私政策的指引做出您认为适当的选择。本隐私政策中涉及的相关术语，我们尽量以简明扼要的表述，并提供进一步说明的链接，以便您更好地理解。您使用或在我们更新本隐私政策后（我们会及时提示您更新的情况）继续使用我们的产品与/或服务，即意味着您同意本隐私政策(含更新版本)内容，并且同意我们按照本隐私政策收集、使用、保存和共享您的相关信息。如对本隐私政策或相关事宜有任何问题，您可随时通过发送邮件至jdcloud@jd.com 或拨打我们的咨询热线400-615-1212与我们联系。<br />
					<span style="display: inline-block;width: 24px;"></span>一、适用范围<br />
						<span style="display: inline-block;width: 24px;"></span><span style="display: inline-block;width: 24px;"></span>1.1本隐私权政策适用于京东智联云网站所有服务，包括向您提供页面浏览、网站登录服务，以及通过京东智联云网站向您提供的技术服务。<br />
						<span style="display: inline-block;width: 24px;"></span><span style="display: inline-block;width: 24px;"></span>1.2本隐私权政策不适用于其他第三方通过京东智联云网站向您提供的服务。例如，京东智联云云市场上的服务商依托云市场向您提供服务时，您向服务商提供的信息不适用本隐私政策。<br />
						<span style="display: inline-block;width: 24px;"></span><span style="display: inline-block;width: 24px;"></span>1.3需要特别说明的是，作为京东智联云的用户，若您利用京东智联云的技术服务，为您的用户再行提供服务，因您的业务数据属于您所有，您应当另行与您的用户约定相应的隐私政策。<br />
					<span style="display: inline-block;width: 24px;"></span>二、我们收集您的信息的范围<br />
						<span style="display: inline-block;width: 24px;"></span><span style="display: inline-block;width: 24px;"></span>本隐私政策中涉及的个人信息包括：<br />
						<span style="display: inline-block;width: 24px;"></span><span style="display: inline-block;width: 24px;"></span>基本信息：您为完成京东智联云账户的注册、管理、实名认证等，您提交的真实、合法、有效的个人姓名、联系地址、联系电话号码、电子邮箱；<br />
						<span style="display: inline-block;width: 24px;"></span><span style="display: inline-block;width: 24px;"></span>个人身份信息：您使用京东智联云域名注册、网站备案、云市场等服务时，您提交身份证、护照、回乡证、台胞证等；<br />
						<span style="display: inline-block;width: 24px;"></span><span style="display: inline-block;width: 24px;"></span>网络身份标识信息：包括系统账号、密码、IP地址、邮箱地址；<br />
						<span style="display: inline-block;width: 24px;"></span><span style="display: inline-block;width: 24px;"></span>个人财产信息：您在京东智联云交易和消费记录、以及代金券等虚拟财产信息；<br />
						<span style="display: inline-block;width: 24px;"></span><span style="display: inline-block;width: 24px;"></span>个人上网记录：网站浏览记录、软件使用记录、日志信息；<br />
						<span style="display: inline-block;width: 24px;"></span><span style="display: inline-block;width: 24px;"></span>个人常用设备信息：包括硬件型号、操作系统类型、IDFA在内的描述个人常用设备基本情况的信息；<br />
						<span style="display: inline-block;width: 24px;"></span><span style="display: inline-block;width: 24px;"></span>个人敏感信息是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息，本隐私政策中涉及的个人敏感信息包括：<br />
						<span style="display: inline-block;width: 24px;"></span><span style="display: inline-block;width: 24px;"></span>您的财产信息（包括交易记录及代金券等虚拟财产信息）；个人身份信息（包括身份证、护照、回乡证、台胞证）；<br />
						<span style="display: inline-block;width: 24px;"></span><span style="display: inline-block;width: 24px;"></span>网络身份识别信息（包括账户名、邮箱地址及与前述有关的密码）；<br />
						<span style="display: inline-block;width: 24px;"></span><span style="display: inline-block;width: 24px;"></span>其他信息（包括个人电话号码、手机号码、网页浏览记录）。<br />
					<span style="display: inline-block;width: 24px;"></span>三、 您可选择是否授权我们收集和使用您的个人信息的情形<br />
						<span style="display: inline-block;width: 24px;"></span><span style="display: inline-block;width: 24px;"></span>如果您不提供这些个人信息，您依然可以进行浏览我们的产品及/或服务，但您可能无法使用我们的产品及/或服务，主要包括：<br />
						<span style="display: inline-block;width: 24px;"></span><span style="display: inline-block;width: 24px;"></span>1.不提供手机号码，将无法进行账号注册；无法执行部分需要通过手机验证码以确认用户身份的操作，如找回密码。<br />
						<span style="display: inline-block;width: 24px;"></span><span style="display: inline-block;width: 24px;"></span>2.不进行实名认证（个人实名认证需要提供姓名、身份证号、银行账号；企业实名认证需要提供营业执照信息及照片、对公银行账号、法人姓名和身份证号及照片、授权人姓名和身份证号及照片），无法购买和使用我们的产品及/或服务，如云主机、云存储；无法进行提现。<br />
					<span style="display: inline-block;width: 24px;"></span>四、 我们收集您的信息的方式<br />
						<span style="display: inline-block;width: 24px;"></span><span style="display: inline-block;width: 24px;"></span>4.1您申请成为京东智联云会员<br />
							<span style="display: inline-block;width: 24px;"></span><span style="display: inline-block;width: 24px;"></span><span style="display: inline-block;width: 24px;"></span>4.1.1当您在京东智联云网站创建京东智联云账户时，我们通过您主动提交的您在中华人民共和国境内的手机号码，以及您设置的账号。<br />
							<span style="display: inline-block;width: 24px;"></span><span style="display: inline-block;width: 24px;"></span><span style="display: inline-block;width: 24px;"></span>4.1.2在您注册完成京东智联云账户后，您可以在账户“基本资料”一栏中继续填写您的信息，包括（1）您的会员身份类型（个人、企业）、单位名称（如果您已完成实名认证，单位名称将会以您的实名认证信息为准）、主营业务，（2）联系信息（所在地区、街道）。您若不提供这些信息，将不会影响您对某一服务的使用。您提供的本条第（1）类信息，会帮助我们更了解您对于京东智联云服务需求，以便京东智联云有针对性的向您推广、介绍产品；您提供的本条第（2）类信息，京东智联云可能会利用如上方式向您推广、宣传产品、邮寄业务通知（含账单）或与您进行业务沟通。<br />
							<span style="display: inline-block;width: 24px;"></span><span style="display: inline-block;width: 24px;"></span><span style="display: inline-block;width: 24px;"></span>4.1.3您的账号下创建子账号时，需要收集子账号主体的姓名、手机号码、电子邮箱。您提交的子账号的个人信息视为您已经获得子账号主体的授权并提交子账号的上述信息。<br />
							<span style="display: inline-block;width: 24px;"></span><span style="display: inline-block;width: 24px;"></span><span style="display: inline-block;width: 24px;"></span>4.1.4 在您注册完成京东智联云账户后，您可在账号的管理控制台提交联系人信息，包括您指定联系人的邮箱、手机号码。京东智联云将通过如上信息向您发送业务通知或与您进行业务沟通。<br />
							<span style="display: inline-block;width: 24px;"></span><span style="display: inline-block;width: 24px;"></span><span style="display: inline-block;width: 24px;"></span>4.1.5如果您仅需使用浏览、搜索等基本服务，您不需要注册成为我们的会员及提供上述信息。<br />
							<span style="display: inline-block;width: 24px;"></span><span style="display: inline-block;width: 24px;"></span><span style="display: inline-block;width: 24px;"></span>4.1.6如果您已经注册有京东账号的，您可利用前述账号登录京东智联云的网站。您通过京东账号登录京东智联云网站的，您的京东注册账号的实名注册信息（姓名/企业名称、身份证号/营业执照号、手机号/邮箱）将同步至京东智联云。<br />
						<span style="display: inline-block;width: 24px;"></span><span style="display: inline-block;width: 24px;"></span>4.2您使用京东智联云服务<br />
							<span style="display: inline-block;width: 24px;"></span><span style="display: inline-block;width: 24px;"></span><span style="display: inline-block;width: 24px;"></span>4.2.1在您使用京东智联云的服务时，您通过您的账号提供您的真实身份信息以完成实名认证，在此过程中，您将提交您的姓名（单位主体名称）、身份证号码（营业执照号码）、企业注册地区、企业性质、企业名称和营业执照注册号，企业授权人信息以及银行账户信息（包括开户行、银行账号）。<br />
							<span style="display: inline-block;width: 24px;"></span><span style="display: inline-block;width: 24px;"></span><span style="display: inline-block;width: 24px;"></span>4.2.2在接受域名、备案等服务前，根据中华人民共和国法律，京东智联云将通过京东智联云网站页面向您展示您需要提交的信息，以届时网站页面展示为准，如果您不使用某些服务，则无需提供相关信息。<br />
							<span style="display: inline-block;width: 24px;"></span><span style="display: inline-block;width: 24px;"></span><span style="display: inline-block;width: 24px;"></span>4.2.3您使用我们的服务后，我们还将根据您的需要，根据您提供的收件人的姓名、联系方式、收货地址，为您寄送合同及/或发票等。<br />
							<span style="display: inline-block;width: 24px;"></span><span style="display: inline-block;width: 24px;"></span><span style="display: inline-block;width: 24px;"></span>4.2.4我们会根据您在软件安装及使用中授予的具体权限，接收并记录您所使用的设备相关信息（例如设备型号、操作系统版本、设备设置等软硬件特征信息）、设备所在位置相关信息（IP地址）。我们可能会将前面两类信息进行关联，以便我们能在不同设备上为您提供一致的服务。<br />
							<span style="display: inline-block;width: 24px;"></span><span style="display: inline-block;width: 24px;"></span><span style="display: inline-block;width: 24px;"></span>4.2.5当您使用我们的网站或客户端提供的服务时，我们会自动收集您对我们服务的详细使用情况，作为有关网络日志保存。例如您的搜索查询内容、IP地址、浏览器的类型、电信运营商、使用的语言、访问日期和时间及您访问的网页记录等。<br />
							<span style="display: inline-block;width: 24px;"></span><span style="display: inline-block;width: 24px;"></span><span style="display: inline-block;width: 24px;"></span>4.2.6请注意，单独的设备信息、日志信息等是无法识别特定自然人身份的信息。如果我们将这类信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类信息将被视为个人信息，除取得您授权或法律法规另有规定外，我们会将该类个人信息做去标识化处理。<br />
							<span style="display: inline-block;width: 24px;"></span><span style="display: inline-block;width: 24px;"></span><span style="display: inline-block;width: 24px;"></span>4.2.7用户账户的支持信息：基于您使用京东智联云服务而产生的用户的咨询记录、报障记录和针对用户故障的排障过程（如通信或通话记录），京东智联云将通过记录、分析这些信息以便更及时响应您的帮助请求，以及用于改进服务。<br />
						<span style="display: inline-block;width: 24px;"></span><span style="display: inline-block;width: 24px;"></span>4.3我们可能会通过 Cookies 和其他相关技术收集和使用您的信息。<br />
							<span style="display: inline-block;width: 24px;"></span><span style="display: inline-block;width: 24px;"></span><span style="display: inline-block;width: 24px;"></span>4.3.1我们使用 Cookies 的具体用途包括： 记住您的身份。例如：Cookies 有助于我们辨认您作为我们的注册用户的身份。 分析您使用我们服务的情况，以便为您提供更加周到的个性化服务，包括定制化页面、推荐等服务。<br />
							<span style="display: inline-block;width: 24px;"></span><span style="display: inline-block;width: 24px;"></span><span style="display: inline-block;width: 24px;"></span>4.3.2您可以通过浏览器设置拒绝或管理 Cookies。但请注意，如果停用 Cookies，您有可能无法享受最佳的服务体验，某些功能的可用性可能会受到影响。<br />
							<span style="display: inline-block;width: 24px;"></span><span style="display: inline-block;width: 24px;"></span><span style="display: inline-block;width: 24px;"></span>4.3.3通过京东智联云 Cookies 记录的有关信息，将适用本隐私声明。<br />
						<span style="display: inline-block;width: 24px;"></span><span style="display: inline-block;width: 24px;"></span>4.4我们从第三方获得您个人信息的情形 我们可能从第三方获取您授权共享的账户信息，并在您同意本隐私政策后将您的第三方账户与您的京东智联云账户绑定，使您可以通过第三方账户直接登录并使用我们的产品与/或服务。我们会将依据与第三方的约定、对个人信息来源的合法性进行确认后，在符合相关法律和法规规定的前提下，使用您的这些个人信息。<br />
						<span style="display: inline-block;width: 24px;"></span><span style="display: inline-block;width: 24px;"></span>4.5当您终止使用我们的产品与/或服务时，或您使用我们的产品与/或服务之服务期届满后，我们将立即停止继续收集您的个人信息。
				</p>
			</div>
			<div slot="footer" class="dialog-footer">
			  <el-button style="color: #409eff;" type="text" @click="nodoread">不同意</el-button>
			  <el-button style="background-color: #409eff;border: none;" type="primary" @click="doRead">我同意</el-button>
			</div>
		</el-dialog>
		<el-dialog :visible.sync="is_show" :title="'查看'">
			<div>
				<img :src="item" v-for="item in url" style="width: 200px;height: 200px;margin:20px;"/>
			</div>
		</el-dialog>
	</el-card>
</template>

<script>
import debounce from 'lodash/debounce'

export default {
  data () {
    return {
      rules: {
        optionCheck: [
          { type: 'array', required: true, message: '请勾选我已详细阅读并同意', trigger: 'change' }
        ]
      },
      dialogVisible: false,
      visible: false,
      readonly: true,
      optionCheck: '', // 同意协议按钮
      ruleForm: {
        optionCheck: []
      },
      dataForm: {
        id: '',
        taskDesc: '',
        taskRequire: '',
        requirePerson: '',
        budget: '',
        contractCode: '',
        startDate: '',
        endDate: '',
        status: '',
		taskCode: '',
		processDTOList: [],
		acceptDTOList: []
      },
	  url:[],
	  is_show:false
    }
  },
  created () {
    this.dataForm.id = this.$route.params.id || ''
    this.init()
  },
  computed: {},
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/plat/task/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {
      })
    },
    doRead () {
            	this.ruleForm.optionCheck[0] ? this.ruleForm.optionCheck[0] = '协议' : this.ruleForm.optionCheck.push('协议')
            	this.dialogVisible = false
    },
    nodoread () {
      this.ruleForm.optionCheck = []
      this.dialogVisible = false
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['ruleForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        let submitForm = {}
        submitForm.taskId = this.dataForm.id
        this.$http.post('/sys/plat/task/accept', submitForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: '接收任务成功',
            type: 'success',
            duration: 1000,
            onClose: () => {
              this.$router.back(-1)
            }
          })
        }).catch(() => {
        })
      })
    }, 1000, { 'leading': true, 'trailing': false }),
	yulan (url) {
      let urls = url.split(',')
      this.url = urls
      this.is_show = true
    }
  }
}
</script>
